import React from "react";
import "./Projects.scss";
import ETCShopImg from "../../Assets/Images/etc-shop.png";
import SoccerClubImg from "../../Assets/Images/soccer-club.png";
import RailRover from "../../Assets/Images/rail-rover.png";
import { AiFillCaretRight } from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";
import { BsCodeSlash } from "react-icons/bs";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";

const Projects = () => {
  return (
    <div className="custom-padding-top projects">
      <div className="container">
        <Fade left>
          <h1 className="custom-font text-center display-3 fw-bold mb-5">
            Featured Projects<span className="dot">.</span>
          </h1>
        </Fade>
        <Fade>
          <div className="row row-cols-1 row-cols-md-3 gx-0 text-center">
            <div className="col mb-5">
              <div className="card h-100 my-3 mx-3">
                <img src={ETCShopImg} className="card-img-top" alt="..." />
                <div className="card-body">
                  <h5 className="card-title">ETC Shop</h5>
                  <p className="card-text">
                    A full-stack single-page e-commerce electronic web app.
                    Login system with firebase and private routes. Users can buy
                    products and see their purchase records on the order page.
                    Admin panel, where admin can do CRUD operations.
                  </p>
                </div>
                <div className="btn-groups mb-3">
                  <a
                    href="https://infallible-fermat-c4454d.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn1 py-2 px-3">
                      Live <FiExternalLink />
                    </button>
                  </a>
                  <a
                    href="https://github.com/rafiferdos/etc-shop"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn2 py-2 px-3">
                      Code <BsCodeSlash />
                    </button>
                  </a>
                </div>
                <div className="card-footer">
                  <small className="text-muted">Created on May, 2021</small>
                </div>
              </div>
            </div>
            <div className="col mb-5">
              <div className="card h-100 my-3 mx-3">
                <img src={RailRover} className="card-img-top" alt="..." />
                <div className="card-body">
                  <h5 className="card-title">Rail Rover</h5>
                  <p className="card-text">
                    A single-page e-tickets booking web app with firebase login
                    system. There is a dynamic Google Map on the booking page.
                  </p>
                </div>
                <div className="btn-groups mb-3">
                  <a
                    href="https://jolly-spence-552bdf.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn1 py-2 px-3">
                      Live <FiExternalLink />
                    </button>
                  </a>
                  <a
                    href="https://github.com/Porgramming-Hero-web-course/react-auth-rafiferdos"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn2 py-2 px-3">
                      Code <BsCodeSlash />
                    </button>
                  </a>
                </div>
                <div className="card-footer">
                  <small className="text-muted">Created on April, 2021</small>
                </div>
              </div>
            </div>
            <div className="col mb-5">
              <div className="card h-100 my-3 mx-3">
                <img src={SoccerClubImg} className="card-img-top" alt="..." />
                <div className="card-body">
                  <h5 className="card-title">Soccer Club</h5>
                  <p className="card-text">
                    This is a simple website about soccer team details. Created
                    with React and React Router. It shows team details and image
                    and other things dynamically.
                  </p>
                </div>
                <div className="btn-groups mb-3">
                  <a
                    href="https://suspicious-shaw-7e2c73.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn1 py-2 px-3">
                      Live <FiExternalLink />
                    </button>
                  </a>
                  <a
                    href="https://github.com/Porgramming-Hero-web-course/react-router-rafiferdos"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn each-project-btn2 py-2 px-3">
                      Code <BsCodeSlash />
                    </button>
                  </a>
                </div>
                <div className="card-footer">
                  <small className="text-muted">
                    Created on February, 2021
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Fade>
        <Fade top>
          <div className="project-btn-area text-center mb-4">
            <Link to="/allprojects">
              <button className="btn custom-project-btn py-3 px-5 mt-5">
                See More Projects <AiFillCaretRight className="arrow" />
              </button>
            </Link>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Projects;
